import http from "../../services/httpService";
import { injectHtml } from "../../utils/htmlUtil";
import { openDialog, dialogModel } from "../common/dialog";
import { error, isEmpty} from "../common/global";
import { catchError } from "../../utils/errorUtil";

const props = {
    facetsWrapper: '.facet-wrapper',
    facetsWrapperMobile: '#facet-w-mobile',
    facetsWrapperDesktop: '#facet-w-desktop',
    productListDisplayWrapper: '#product-list-display-wrapper',
    productListWrapper: '#product-list-wrapper',
    selectedDynamicFilters: '#SelectedDynamicFilters',
    selectedSystemFilters: '#SelectedSystemFilters',
    loadingFacets: '.loading-facets',
    clearAllSelectedFilters: '.clear-all-selected-filters'
};

var filters = [];

export function initFacets() {

    if ($(props.facetsWrapper).length) {
        bindUpdateProductList();
        bindFacetList();
    }
}

async function updateProductList(productListVm, buildPaginationVm) {

    const requestResult = await getProductListService(productListVm);

    await injectHtml(props.productListWrapper, requestResult);
}

async function bindFacetList() {

    if ($(props.facetsWrapper).length > 0) {

        //NOTE: facets are built once upon initial page load (when a category is selected or a search is run)
        //when a facet is changed the products are reloaded, but facets remain as they are

        //TODO: display a loading graphic?

        // Build Product List VM. No need to pass pagination info back as facets acts independently of this
        var productListVm = new ProductFiltersVm();
        productListVm.Pagination = new PaginationVm();
        productListVm.SearchValue = GetSearchValue();
        productListVm.CategoryId = getCategoryId();
        //ProductFiltersVm.SortBy = $('#SortBy').val();

        //facets
        var pipeDelimitedFacets = $(props.selectedDynamicFilters).val();
        var pipeDelimitedSystemFacets = $(props.selectedSystemFilters).val();

        if (!isEmpty(pipeDelimitedFacets)) {

            var selectedFacets = pipeDelimitedFacets.split("|");

            productListVm.Facets = selectedFacets;
        }

        if (!isEmpty(pipeDelimitedSystemFacets)) {

            var selectedSystemFacets = pipeDelimitedSystemFacets.split("|");

            productListVm.SelectedSystemFacets = selectedSystemFacets;
        }

        //mobile facets
        const mobileRequestResult = await buildFacetListService(productListVm);

        await injectHtml(props.facetsWrapperMobile, mobileRequestResult);

        //desktop facets
        //desktop is provided with an additional parameter to vary key classes applied (to ensure key events are not bound twice)
        productListVm.NameOverride = "desktop";

        const desktopRequestResult = await buildFacetListService(productListVm);

        await injectHtml(props.facetsWrapperDesktop, desktopRequestResult);

        //display effects for both facet types
        $(props.loadingFacets).hide();
        $('#facet-w-desktop, #facet-w-mobile, .show-results').removeClass('hidden').clearQueue();

        setTimeout(function () {

            //TODO: test to see if this is still necessary. not waiting for the async data calls to compelte, but the html binding.
            //bind click events
            bindUpdateProductList();
            bindFacetClickEvents();

            bindClearAllSelectedEvents();

            //check to see if the #product-list-display-wrapper element is present on the page. if it is the products list was pre-loaded; this only occurs if there are no filters set 
            //within the querystring that is called to display the page category (i.e. there are no filters set).

            //if this is the case we do not need to call the service to build the products list view once the factes are loaded (as products have ben pr-loaded and the facets view will not influence
            //the list of products returned (in its current state)).
            if ($('#product-list-display-wrapper').length == 0) {

                //call function to populate the products list
                UpdateProductListHelper(1);
            }

        }, 100);
    }
    else {

        //if facets are not used loads products regardless
        //UpdateProductListHelper(1);
    }
}


function facetBinderHelper(item) {

    var commName = ".facet-chk-" + item.val();
    var checked = item.prop('checked');

    $(commName).not(item).each(function () {
        $(this).prop('checked', checked);
    });

    //see if any checkboxes are checked - if so show the 'clear all, if not hide it

    var selectedFilterCount = $('.facet-option:checked').length;

    if (selectedFilterCount == 0) {

        $(props.clearAllSelectedFilters).hide(500);
    }
    else {

        $(props.clearAllSelectedFilters).show(500);
    }

}

function facetBinderHelperWithRefresh(item) {

    facetBinderHelper(item);

    UpdateProductListHelper(1);
}


function bindUpdateProductList() {

    $("#SortBy").off("change").on("change", function (e) {

        UpdateProductListHelper(1);
    });

    bindFacetBinderHelper(".facet-system-option");
    bindFacetBinderHelper(".facet-system-option-desktop");

    bindFacetBinderHelper(".facet-option");
    bindFacetBinderHelper(".facet-option-desktop");

    //do i not like this
    $(".value-range-submit").off("click").on("click", function (e) {

        $('.value-range-minimum-desktop').val($('.value-range-minimum').val());
        $('.value-range-maximum-desktop').val($('.value-range-maximum').val());

        UpdateProductListHelper(1);
    });

    $(".value-range-submit-desktop").off("click").on("click", function (e) {

        $('.value-range-minimum').val($('.value-range-minimum-desktop').val());
        $('.value-range-maximum').val($('.value-range-maximum-desktop').val());

        UpdateProductListHelper(1);
    });

    $('.value-range-field').off("keypress").on("keypress", function (e) {
        if (e.keyCode == 13) {

            $(this).siblings('button.vrs-family').click();
            return false;
        }
    });

    $(".product-list-pagination a").off("click").on("click", function (e) {
        e.preventDefault();

        if ($(this).hasClass('disabled')) {
            return false;
        }

        UpdateProductListHelper($(this).data('page'));
    });
}


function bindClearAllSelectedEvents() {

    $(props.clearAllSelectedFilters).off("click").on("click", function (e) {

        $('.facet-option').prop('checked', false);
        $('.facet-option-desktop').prop('checked', false);

        $('.facet-system-option').prop('checked', false);
        $('.facet-system-option-desktop').prop('checked', false);

        $(props.clearAllSelectedFilters).hide(500);

        UpdateProductListHelper(1);
    });
}



//helpers

function bindFacetBinderHelper(element_identifier) {

    $(element_identifier).off("change").on("change", function (e) {

        facetBinderHelperWithRefresh($(this));
    });
}

function GetSearchValue() {

    var searchValue = '';

    if ($('#SearchValueMobile').is(':visible')) {
        searchValue = $('#SearchValueMobile').val();
    }
    else if ($('#SearchValueLarge').is(':visible')) {
        searchValue = $('#SearchValueLarge').val();
    }
    else {
        searchValue = $('#SearchValueMobile').val();
    }

    return searchValue;
}

function buildProductListVm(pageId) {

    var searchValue = GetSearchValue();

    var selectedFacets = [];
    $('.facet-option:checked').each(function () {
        selectedFacets.push($(this).val());
    });

    var selectedSystemFacets = [];
    $('.facet-system-option:checked').each(function () {
        selectedSystemFacets.push($(this).attr('id'));
    });

    // Product List VM
    var productListVm = new ProductFiltersVm();
    productListVm.Pagination = new PaginationVm();
    productListVm.SearchValue = searchValue;
    productListVm.CategoryId = getCategoryId();
    productListVm.Facets = selectedFacets;
    productListVm.SelectedSystemFacets = selectedSystemFacets;
    productListVm.MinValue = $('.value-range-minimum').val();
    productListVm.MaxValue = $('.value-range-maximum').val();
    productListVm.ProductsColumnCount = $(props.productListWrapper).data('cc');

    //productListVm.SortBy = $('#SortBy').val();
    productListVm.ProductsPerPage = 20;
    productListVm.Pagination.CurrentPage = pageId;

    return productListVm;
}

function UpdateProductListHelper(pageId) {
    $('.product-list-pagination .loading-ripple').removeClass('hidden');

    var productListVm = buildProductListVm(pageId);

    // Build Pagination VM
    var buildPaginationVm = new BuildProductPaginationVm();

    buildPaginationVm.ProductCount = $('#ProductCount').val();
    buildPaginationVm.ProductsPerPage = $('#ProductsPerPage').val();
    buildPaginationVm.CurrentPage = pageId;
    buildPaginationVm.SortBy = $('#SortBy').val();

    // Update Url
    if (history.pushState) {

        var page = pageId;

        if (page == undefined || page == 1) {
            //correct page value if it's a filter caused rebuild of the data
            page = '';
        }

        //rebuild url from scratch each time

        //so; check for:

        var url = '';
        // - searchterm
        var searchTerm = GetSearchValue();

        if (!isEmpty(searchTerm)) {
            url = AddToUrl(url, 's=' + searchTerm);
        }

        //facets
        filters = getFilters();

        if (filters.length > 0) {
            url = AddToUrl(url, filters.join("&"));
        }

        //page
        if (page != '') {
            url = AddToUrl(url, 'page=' + page);
        }

        var newurl = window.location.origin + window.location.pathname + url;
        window.history.pushState({ path: newurl }, '', newurl);
    }

    updateProductList(productListVm, buildPaginationVm);
}

function AddToUrl(url, value) {

    //helper to build the querystring for the pages url
    if (url == '') {
        url = '?' + value;
    }
    else {
        url = url + '&' + value;
    }

    return url;
}


function getFilters() {
    filters = [];
    $(".facet-group").each(function () {
        var key = $(this).data("key");
        var items = $(this).find(".facet-option:checked");
        var itemValues = [];

        if (items.length > 0) {
            itemValues = [];
            items.each(function () {
                itemValues.push($(this).data("key"));
            });
            filters.push(key + "=" + itemValues.join("|"));
        }

        var systemItems = $(this).find(".facet-system-option:checked");
        if (systemItems.length > 0) {
            itemValues = [];
            systemItems.each(function () {
                itemValues.push($(this).data("key"));
            });
            filters.push(key + "=" + itemValues.join("|"));
        }
    });

    return filters;
}

function bindFacetClickEvents() {

    $(".facet-label").off("click").on("click", function () {

        var id = $(this).data("facetid");

        var parent = $(this).closest('.facet-item');

        var linked_checkbox = parent.find('input[type="checkbox"]');

        var checkboxes = $('.' + id);

        if (linked_checkbox.is(":checked")) {
            checkboxes.prop('checked', false);
        }
        else {
            checkboxes.prop('checked', true);
        }

        linked_checkbox.change();
    });
}


function getCategoryId() {

    //shared function to get the category id that may be bound to a data attribute of the wrapping div element for the products and facets list
    return $(props.productListDisplayWrapper).data('plc-id');
}

//---- API CALLS ----\\

// NOTE: WIthin the response is an object with a property called 'data'. This contains the HTML.

async function getProductListService(data) {

    //gets a list of products for the filter options passed
    const response = await http.post('/getproductlist', data);

    return response.data;
}

async function buildFacetListService(data) {

    //gets a list of products for the filter options passed
    const response = await http.post('/buildfacetlist', data);

    return response.data;
}



//---- MODELS ----\\
function ProductFiltersVm(SearchValue, CategoryId, ProductsPerPage, Pagination, Facets, SelectedSystemFacets, MinValue, MaxValue, SortBy, NameOverride, ProductsColumnCount) {
    this.SearchValue = SearchValue;
    this.CategoryId = CategoryId;
    this.ProductsPerPage = ProductsPerPage;
    this.Pagination = PaginationVm;
    this.Facets = Facets;
    this.SelectedSystemFacets = SelectedSystemFacets;
    this.MinValue = MinValue;
    this.MaxValue = MaxValue;
    this.SortBy = SortBy;
    this.NameOverride = NameOverride;
    this.ProductsColumnCount = ProductsColumnCount;

}

function PaginationVm(CurrentPage) {
    this.CurrentPage = CurrentPage;
}

function BuildProductPaginationVm(ProductCount, ProductsPerPage, CurrentPage, SortBy) {
    this.ProductCount = ProductCount;
    this.ProductsPerPage = ProductsPerPage;
    this.CurrentPage = CurrentPage;
    this.SortBy = SortBy;
}